export default __webpack_public_path__ + "static/media/eddy.738878f9.png";